import React, {useCallback, useEffect, useState} from 'react';
import {FlexBox, MarginBox} from "../../ui/styled";
import styled, {useTheme} from "styled-components";
import {useSelector} from "react-redux";
import {ImageLane} from "../../common";
import {useQueryClient} from "@tanstack/react-query";
import {calcKda, sllPosition} from "../../../function";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import {Link} from "react-router-dom";


const DarkModeText = styled.span`
  font-size: 12px;
  white-space: pre-wrap;
  line-height: 17px;
  font-weight: 700;
  color: ${props => props.theme.color.dark_100};
  margin: 0 4px;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  bottom: 0;
  right: 34px;
`;

const ExtraText = styled.span`
  font-size: 12px;
  line-height: 17px;
  font-weight: bold;
  color: ${props => props.theme.color.red_600};
`;
const GreenText = styled.span`
  color: #0DBAAE;
`;

const Wrapper = styled(FlexBox)`
  justify-content: center;
  margin-bottom: 47px;
  position: relative;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
`;
const BlackText = styled.span`
  margin-left: 5px;
  text-align: left;
  color: ${props => props.theme.color.dark_100};
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  margin-top: 4px;
  white-space: pre-wrap;
`;

const EmptyWrapper = styled.div`
    height: 54px;
`;

const AbsoluteWrapper = styled.div`
  position: absolute;
`;

const ImageTextBox = styled.div`
  margin-bottom: 5px;
`;

const ImageTextBoxSpan = styled.span`
  font-weight: 400;
  font-size: 12px;
  margin-left: 3px;
  color: ${props => props.theme.color.dark_200};
`;
const ImageTextBoxBold = styled.span`
  font-weight: 600;
  font-size: 12px;
  color: ${props => props.theme.color.dark_200};
`;

const ImageAbsolute = styled.div`
  position: absolute;
  right: 60px;
`;

const TalkAbsoluteWrapper = styled.div`
  position: absolute;
  right: 51px;
  bottom: 4px;
  cursor: pointer;
`;

const ImageRelative = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const AbsoluteTextBox = styled.div`
  display: flex;
  flex-direction: column;
  right: 25px;
  top: 18px;
  position: absolute;
  width: 60px;
  height: 42px;
  font-family: DungGeunMo;
  color: #fff;
`;

const Title = styled.div`
  font-family: DungGeunMo;
  font-weight: 400;
  font-size: 18px;
  margin-left: 8px;

`;
const BigText = styled.span`
  font-size: 32px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 3.2px;
`;

const SmallText = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: -0.6px;
`;

const ContentBox = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 425px;
  justify-content: center;
`;
const AiInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  height: 96px;
  margin-left: 7px;

  .imgLane {
    width: 25px;
    height: 25px;
  }
`;
const NameBox = styled.div`
  width: 144px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: DungGeunMo;
  font-weight: 400;
  font-size: 16px;
`;
const DotGroupBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 8px;
  gap: 5px;
`;
const DotBox = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  font-family: DungGeunMo;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  opacity: 0.3;
  width: 4px;
  height: 4px;
  background-color: #fff;

  &.embla__dot--selected {
    opacity: 1;
    width: 20px;
  }
`;


const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
const KDA = styled.div`
  font-family: DungGeunMo;
  font-weight: 400;
  font-size: 18px;
  color: #EFAD0A;
`;

const CalcKDABox = styled.div`
  white-space: nowrap;
  margin-left: 4px;
  font-family: DungGeunMo;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: #A03231;
`;
const MVPButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 4px;
`;
const AiScoreBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
const AiScoreTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  margin-right: 3px;
`;
const AiScoreText = styled.div`
  margin-inline: 1px;
  text-align: center;
  z-index: 0;
  position: relative;
  font-family: DungGeunMo;
  font-weight: 400;
  font-size: 40px;
  color: #fff;
  margin-top: 10px;

  &::before {
    z-index: -1;
    content: attr(data-content);
    position: absolute;
    left: 0;
    -webkit-text-stroke: 6px ${props => {
      let color = props.dataColor
      return color
    }};
  }
`;

const AiScoreOne = styled(AiScoreText)`
  margin-inline: -3px;
`;

const MvpBox = styled.div`
  display: block;
  position: relative;
`;
const MVPImageBox = styled.div`
  top: 13px;
  right: 3px;
  position: absolute;
  width: 90px;
  height: 90px;
  border-radius: 4px;
`;
const PlayerImage = styled.img`
  border-radius: 4px;
  object-fit: cover;
`;

const InfoBox = styled.div`
  margin-left: 10px;
  display: flex;
  align-items: center;
  width: 390px;
  height: 137px;
  transform: translate3d(0, 0, 0);
  flex: 0 0 100%;
  min-width: 0;
  padding-left: 1rem;
  background-image: url("/images/sll/icon_sll_bannerbg_home.png");
  background-size: 392px 137px;
  background-repeat: no-repeat;
  cursor: pointer;

  &:hover {
    background-image: url("/images/sll/icon_sll_bannerbg_home_hover.png");
  }
`;
const ArrowLeft = styled.button`
  width: 17px;
  height: 28px;
  margin-right: 15px;

  &:disabled {
    opacity: 0.5;
  }
`;
const ArrowRight = styled.button`
  width: 17px;
  height: 28px;
  margin-left: 15px;
  rotate: 180deg;

  &:disabled {
    opacity: 0.5;
  }
`;

const CarouselBox = styled.div`
  width: 400px;
  display: flex;
  flex-direction: row;
  overflow: hidden;

  .embla__container {
    width: 392px;
    display: flex;
    touch-action: pan-y pinch-zoom;

  }
`;
const HomeNotice = () => {
    const queryClient = useQueryClient();
    const currentLang = useSelector((state) => state.translation.lang);
    const data = queryClient.getQueryData(['sllMvp', currentLang]);


    // if (currentLang !== 'KOR' || !data) {
    //     return (
    //         <EmptyWrapper/>
    //     )
    // }
    //
    return null
};
const NoticeItem = () => {
    const titleList = ['종합 1위', '탑 MVP', '정글 MVP', "미드 MVP", '바텀 MVP', '서폿 MVP']
    const queryClient = useQueryClient();
    const [isFirst,setIsFirst] = useState(false);
    const theme = useTheme();
    const [emblaRef, emblaApi] = useEmblaCarousel({loop: true, direction: 'ltr'}, [Autoplay({
        playOnInit: true,
        delay: 3000,
        stopOnInteraction:false,
        stopOnFocusIn:false
    })]);
    const currentLang = useSelector((state) => state.translation.lang);
    const data = queryClient.getQueryData(['sllMvp', currentLang]);
    const onNavButtonClick = useCallback((emblaApi) => {
        const autoplay = emblaApi?.plugins()?.autoplay
        if (!autoplay) return

        const resetOrStop =
            autoplay.options.stopOnInteraction === false
                ? autoplay.reset
                : autoplay.stop

        resetOrStop()
    }, [])
    const {
        onNextButtonClick
    } = usePrevNextButtons(emblaApi, onNavButtonClick);

    const {selectedIndex, scrollSnaps, onDotButtonClick} =
        useDotButton(emblaApi, onNavButtonClick)

    useEffect(() => {
        if(emblaApi && !isFirst) {
            setTimeout(() => {
                onNextButtonClick()
                setIsFirst(true)
            },1000)
        }
    },[emblaApi,isFirst])


    return (
        <Wrapper width={'736px'}
        >
            <ImageRelative>
                <img src={'/images/sll/background_sll_home.png'} alt={''} width={600} height={280}/>
                <AbsoluteWrapper>
                    <FlexBox justifyContent={'center'} height={'auto'} margin={'5px'}>
                        <img src={`/images/sll/icon_sll_title_home.png`} alt="DEEPLOL" width={360} height={36}/>
                    </FlexBox>
                    <div>
                        <ContentBox>
                            <CarouselBox className={'embla__viewport'} ref={emblaRef}>
                                <div className={'embla__container'}>
                                    {data.map((item, index) => {
                                        return (
                                            <Link key={index} to={'/sll'}>
                                                <InfoBox className={'embla__slide'}>
                                                    <MvpBox>
                                                        <img src={'/images/sll/icon_sll_mvp_home.png'} alt={''}
                                                             width={96}
                                                             height={106}/>
                                                        <MVPImageBox>
                                                            <PlayerImage
                                                                src={`https://ak-deeplol-ddragon-cdn.deeplol.gg/${item.status.toLowerCase()}/${item.status === 'pro' ? item.championship_name : item.name}.png`}
                                                                width={90}
                                                                height={90}
                                                                onError={(e) => e.target.src = '/images/sll/icon_sll_default_home.svg'}
                                                                alt={''}/>
                                                        </MVPImageBox>
                                                    </MvpBox>
                                                    <AiInfoBox>
                                                        <FlexBox alignItems={'flex-start'} height={'auto'}>
                                                            <img src={'/images/sll/icon_sll_aiscore_home.png'} alt={''}
                                                                 width={91}
                                                                 height={21}/>
                                                            <Title>{titleList?.[index] ? titleList[index] : titleList[0]}</Title>
                                                        </FlexBox>
                                                        <FlexBox height={'auto'} alignItems={'flex-start'}>
                                                            <Column>
                                                                <FlexBox height={'32px'} margin={'8px 0 0 0'}>
                                                                    <ImageLane
                                                                        color={'darkgray'}
                                                                        lane={sllPosition(item.position)}
                                                                    />
                                                                    <MarginBox margin={'0 7px 0 8px'}>
                                                                        <Column>
                                                                            <NameBox>NAME:{item.name}</NameBox>
                                                                            <FlexBox height={'auto'}>
                                                                                <KDA>
                                                                                    {item.kills}/{item.deaths}/{item.assists}
                                                                                </KDA>
                                                                                <CalcKDABox>
                                                                                    {calcKda({
                                                                                        assists: item.assists,
                                                                                        deaths: item.deaths,
                                                                                        kills: item.kills
                                                                                    })} KDA
                                                                                </CalcKDABox>
                                                                            </FlexBox>
                                                                        </Column>
                                                                    </MarginBox>
                                                                </FlexBox>
                                                                <MVPButton>
                                                                    <img src={'/images/sll/icon_sll_mvpbutton_home.png'}
                                                                         alt={''}
                                                                         width={156}
                                                                         height={31}/>
                                                                </MVPButton>
                                                            </Column>
                                                            <AiScoreBox>
                                                                <img
                                                                    src={`/images/sll/icon_sll_aiscore${item.ai_score > 75 ? '99' : '57'}_home.png`}
                                                                    alt={''}
                                                                    width={80}
                                                                    height={62}/>
                                                                <AiScoreTextWrapper>
                                                                    {item.ai_score.toString().split('').map((data, index) => {
                                                                        if (index === 0 && data === '1') {
                                                                            return (
                                                                                <AiScoreOne data-content={data}
                                                                                            key={index}
                                                                                            dataColor={item.ai_score > 75 ? '#CD640A' : '#217B7F'}>
                                                                                    {data}
                                                                                </AiScoreOne>
                                                                            )
                                                                        }
                                                                        return (
                                                                            <AiScoreText
                                                                                data-content={data}
                                                                                key={index}
                                                                                dataColor={item.ai_score > 75 ? '#CD640A' : '#217B7F'}>{data}</AiScoreText>
                                                                        )
                                                                    })}
                                                                </AiScoreTextWrapper>
                                                            </AiScoreBox>
                                                        </FlexBox>
                                                    </AiInfoBox>
                                                </InfoBox>
                                            </Link>
                                        )
                                    })}
                                </div>
                            </CarouselBox>
                        </ContentBox>
                    </div>
                    <DotGroupBox>
                        {data.map((_, index) => {
                            return (
                                <DotBox
                                    key={index}
                                    onClick={() => onDotButtonClick(index)}
                                    className={'embla__dot'.concat(
                                        index === selectedIndex ? ' embla__dot--selected' : ''
                                    )}/>
                            )
                        })}
                    </DotGroupBox>

                </AbsoluteWrapper>
            </ImageRelative>
        </Wrapper>
    )
}
export const usePrevNextButtons = (emblaApi, onButtonClick) => {
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

    const onPrevButtonClick = useCallback(() => {
        if (!emblaApi) return
        emblaApi.scrollPrev()
        if (onButtonClick) onButtonClick(emblaApi)
    }, [emblaApi, onButtonClick])

    const onNextButtonClick = useCallback(() => {
        if (!emblaApi) return
        emblaApi.scrollNext()
        if (onButtonClick) onButtonClick(emblaApi)
    }, [emblaApi, onButtonClick])

    const onSelect = useCallback((emblaApi) => {
        setPrevBtnDisabled(!emblaApi.canScrollPrev())
        setNextBtnDisabled(!emblaApi.canScrollNext())
    }, [])

    useEffect(() => {
        if (!emblaApi) return

        onSelect(emblaApi)
        emblaApi.on('reInit', onSelect).on('select', onSelect)
    }, [emblaApi, onSelect])

    return {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick
    }
}


const useDotButton = (emblaApi, onButtonClick) => {
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [scrollSnaps, setScrollSnaps] = useState([])

    const onDotButtonClick = useCallback(
        (index) => {
            if (!emblaApi) return
            emblaApi.scrollTo(index)
            if (onButtonClick) onButtonClick(emblaApi)
        },
        [emblaApi, onButtonClick]
    )

    const onInit = useCallback((emblaApi) => {
        setScrollSnaps(emblaApi.scrollSnapList())
    }, [])

    const onSelect = useCallback((emblaApi) => {
        setSelectedIndex(emblaApi.selectedScrollSnap())
    }, [])

    useEffect(() => {
        if (!emblaApi) return

        onInit(emblaApi)
        onSelect(emblaApi)
        emblaApi.on('reInit', onInit).on('reInit', onSelect).on('select', onSelect)
    }, [emblaApi, onInit, onSelect])

    return {
        selectedIndex,
        scrollSnaps,
        onDotButtonClick
    }
}


export default HomeNotice;